import { useEffect } from 'react'
import { initMetaPixel } from '../utils/metaPixel'

/**
 * Carga el píxel de Meta una sola vez, pero recién cuando el navegador está
 * ocioso: así no compite con la imagen principal ni retrasa el primer pintado.
 */
export function useMetaPixel(): void {
  useEffect(() => {
    let cancelled = false
    const start = () => {
      if (!cancelled) initMetaPixel()
    }

    const idle = (
      window as typeof window & {
        requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number
      }
    ).requestIdleCallback

    const timer = idle
      ? idle(start, { timeout: 3000 })
      : window.setTimeout(start, 2000)

    return () => {
      cancelled = true
      if (!idle) window.clearTimeout(timer)
    }
  }, [])
}
